import React, { Component } from 'react';
import { MenuItem, Nav, NavDropdown } from 'react-bootstrap';
import auth from '../../lib/auth';

class HeaderLinks extends Component {
    logout = () => {
        localStorage.removeItem('patent');
        auth.logout();
    };

    render() {
        return (
            <div>
                <Nav pullRight>
                    <NavDropdown
                        eventKey={4}
                        title={
                            <div>
                                <i className="fa fa-list" />
                                <p className="hidden-md hidden-lg">
                                    Más
                                    <b className="caret" />
                                </p>
                            </div>
                        }
                        noCaret
                        id="basic-nav-dropdown-3"
                        bsClass="dropdown-with-icons dropdown"
                    >
                        <MenuItem eventKey={4.5} onClick={this.logout}>
                            <div className="text-danger">
                                <i className="pe-7s-close-circle" /> Salir
                            </div>
                        </MenuItem>
                    </NavDropdown>
                </Nav>
            </div>
        );
    }
}
export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx